import { cn } from "@repo/ui/lib/utils";
import type { ReactNode } from "react";

export interface AgentChatHeaderProps {
  children?: ReactNode;
  className?: string;
}

/** Thin top strip for action buttons (new chat, history, etc.). Children are left-aligned. */
export function AgentChatHeader({ children, className }: AgentChatHeaderProps) {
  return <div className={cn("flex items-center gap-0.5 px-1.5 py-1.5", className)}>{children}</div>;
}
